import { useEffect } from 'react';

import { hasAuthParams, useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router-dom';

const LoginPage = () => {
  const auth = useAuth();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const from = params.get('from') || '/';

  useEffect(() => {
    if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading) {
      const transferableParams = new URLSearchParams(search);
      transferableParams.delete('from');

      const userState = {
        path: `${from}`,
        searchParams: transferableParams.toString(),
      };

      auth.signinRedirect({ state: { ...userState } });
    }
  }, [auth, from, search]);

  return <></>;
};

export default LoginPage;
